// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_hx-0";
export var optionCard = "_hx-1";